export const ScoreCalculator = (retryScore, incompleteScoring, count, correct, incorrect, correctOnRetry, crPoints, crAnswered, crNotAnswered, crMaxPoints, newStatusCount) => {
  if(newStatusCount > 0 && incompleteScoring)
    incorrect += newStatusCount;

  if(incompleteScoring)
    crAnswered += crNotAnswered;

  if(incompleteScoring && (crPoints === -127 || crPoints === -2 || crPoints === -1))
    crPoints = 0;

  if ((count === 0 || (correct + (incorrect + correctOnRetry) + crAnswered) === 0) && !incompleteScoring) {
    return 'N';
  } else if ((correct + (incorrect + correctOnRetry) + crAnswered === count) || incompleteScoring) {
    return getScore(retryScore, count, correct, incorrect, correctOnRetry, crPoints, crAnswered, crMaxPoints, incompleteScoring);
  } else {
    return 'P';
  }
};

const getScore = (retryScore, count, correct, incorrect, correctOnRetry, crPoints, crAnswered, crMaxPoints, incompleteScoring) => {
  if (crPoints === -1) {
    return 'P';
  } else if (crPoints === -2) {
    return 'NS';
  } else if (correct + incorrect + correctOnRetry + crAnswered === 0) {
    return incompleteScoring ? '0' : 'N';
  } else if (correct + incorrect + correctOnRetry + crAnswered !== count) {
    if (incompleteScoring) {
      incorrect += count - (correct + incorrect + correctOnRetry + crAnswered);
      return getScore(retryScore, count, correct, incorrect, correctOnRetry, crPoints, crAnswered, crMaxPoints, incompleteScoring);
    } else {
      return 'P';
    }
  } else {
    const totalQuestions = correct + incorrect + correctOnRetry + crMaxPoints;
  
    switch (retryScore) {
    case 1:
      return Math.round((correct + crPoints) * 100 / totalQuestions).toString();
    case 2:
      return Math.round(((correct + crPoints + (correctOnRetry / 2)) * 100) / totalQuestions).toString();
    case 3:
      return Math.round(((correct + correctOnRetry + crPoints) * 100) / totalQuestions).toString();
    default:
      return incompleteScoring ? '0' : ' ';
    }
  }
};